import { encodeOpts as paramsSerializer } from '@/utils/encode-opts';
const companiesApiFactory = (axios) => ({
  getCompanies: (params) => axios.get('/companies', { params, paramsSerializer }),
  createCompany: (company) => axios.post('/companies', company),
});

export { companiesApiFactory };
